// Module
var code = `<div class="ep-drawer">
  <div class="ep-header">
    <span class="ep-title">Explain</span>
    <span class="ep-status-badge"></span>
    <button type="button" class="ep-refresh-btn" title="Recompute now">↻</button>
    <button type="button" class="ep-close-btn" aria-label="Close explanation panel">✕</button>
  </div>
  <div class="ep-body"></div>
</div>
`;
// Exports
export default code;